export const GlassSurfaceBackgrounds = Object.freeze({
    Primary: 'primary',
    Secondary: 'secondary'
});

export type GlassSurfaceBackground = (typeof GlassSurfaceBackgrounds)[keyof typeof GlassSurfaceBackgrounds];
